<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-warn"></i> Permission test</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <h1>Administrator rights page</h1>Only those who log in with the admin account have administrator permission and can enter this page. If other accounts want to enter, they will jump to page 403 and log in with the administrator account again.
            <p></p>
            <p>If you want to try, please<router-link to="/login" class="logout">log out</router-link>, just enter an account name and try again.</p>
        </div>

    </div>
</template>

<script>
    export default {
        data: function(){
            return {}
        }
    }
</script>

<style scoped>
h1{
    text-align: center;
    margin: 30px 0;
}
p{
    line-height: 30px;
    margin-bottom: 10px;
    text-indent: 2em;
}
.logout{
    color: #409EFF;
}
</style>